// extracted by mini-css-extract-plugin
export var compactFilters = "_fm-4";
export var detailImage = "_fm-1";
export var dropdownContainer = "_fm-2";
export var imageContainer = "_fm-0";
export var selectedCard = "_fm-3";